import { Theme } from './Theme';
import { themeBase } from './themeBase';
const themeDefaultColors = {
    foreground: '#232730', // 800
    background: '#FFFFFF',
    body: '#FBFBFB',
    primary: '#4575CD',
    secondary: '#575A64',
    success: '#44B48B',
    warning: '#EC8439',
    danger: '#D64260',
    black: '#000000',
    white: '#FFFFFF',
    gray: '#575A64',
    blue: '#1E4199',
    cyan: '#71D2F0',
    seafoam: '#44B48B',
    green: '#9CD95D',
    orange: '#EC8439',
    red: '#D64260',
    pink: '#AB4BB1',
    purple: '#845EDB',
    yellow: '#F3BE34',
    colors: {},
};
export const themeDefault = new Theme({
    name: 'Default',
    ...themeDefaultColors,
    style: themeBase,
});
//# sourceMappingURL=themeDefault.js.map